import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { editLanguage } from '../redux/actions/language.actions';

export const useInitLanguage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const savedLang = localStorage.getItem('language');
    if (savedLang) {
      dispatch(editLanguage(savedLang));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
